import { Injectable, Injector } from "@angular/core";
import { MescService } from "../mesc/mesc.service";
import { CgpAlertDialogService } from "../../shared/cgp-alert-dialog/cgp-alert-dialog.service";

@Injectable()
export class PHFUserService extends MescService {
    constructor(injector: Injector) { super(injector, "phf/CommonHandler/common/GetPHFUsers"); }
}

@Injectable()
export class AllocationService extends MescService {
    constructor(injector: Injector) { super(injector, "phf/Allocation"); }
}

@Injectable()
export class AttachmentService extends MescService {
    constructor(injector: Injector) { super(injector, "phf/Attachment"); }
}

@Injectable()
export class ContainerService extends MescService {
    constructor(injector: Injector) { super(injector, "phf/Container"); }
}

@Injectable()
export class ContainerTypeService extends MescService {
    constructor(injector: Injector) { super(injector, "phf/ContainerType"); }
}

@Injectable()
export class ContainerSourceService extends MescService {
    constructor(injector: Injector) { super(injector, "phf/ContainerSource"); }
}

@Injectable()
export class ContainerStyleService extends MescService {
    constructor(injector: Injector) { super(injector, "phf/ContainerStyle"); }
}

@Injectable()
export class SideService extends MescService {
    constructor(injector: Injector) { super(injector, "phf/Side"); }
}


@Injectable()
export class DistributionCategoryService extends MescService {
    constructor(injector: Injector) {
        super(injector, "PHF/DistributionCategory");
        this.httpErrorHeader = 'Distribution Category Error'
    }
}

@Injectable()
export class DistributionMethodService extends MescService {
    constructor(injector: Injector, private readonly cgpAlertDialog: CgpAlertDialogService) {
        super(injector, "PHF/DistributionMethod");
        this.httpErrorHeader = 'Distribution Method Error'
    }
}

@Injectable()
export class DieService extends MescService {
    constructor(injector: Injector) { super(injector, "PHF/Die"); }
}

@Injectable()
export class DieSourceService extends MescService {
    constructor(injector: Injector) { super(injector, "PHF/DieSource"); }
}

@Injectable()
export class MaterialService extends MescService {
    constructor(injector: Injector) { super(injector, "phf/Material"); }
}

@Injectable()
export class MakeBuyService extends MescService {
    constructor(injector: Injector) { super(injector, "phf/MakeBuy"); }
}

@Injectable()
export class DieFamilyService extends MescService {
    constructor(injector: Injector) { super(injector, "PHF/DieFamily"); }
}

@Injectable()
export class PartService extends MescService {
    constructor(injector: Injector, private readonly cgpAlertDialog: CgpAlertDialogService) { super(injector, "phf/Part"); }

    handleError = (errorResponse: any) => {
        this.cgpAlertDialog.showAlertDialog({
            title: 'Part Error: ',
            alert: 'danger',
            message: errorResponse.error,
            closeLabel: 'Close',
        })
    }
}

@Injectable()
export class PartSourceService extends MescService {
    constructor(injector: Injector) { super(injector, "phf/PartSource"); }
}

@Injectable()
export class PartHandlingService extends MescService {
    constructor(injector: Injector) { super(injector, "phf/PartHandling"); }
}

@Injectable()
export class PartLoadingService extends MescService {
    constructor(injector: Injector) { super(injector, "phf/PartLoading"); }
}

@Injectable()
export class PartTypeService extends MescService {
    constructor(injector: Injector) { super(injector, "phf/PartType"); }
}

@Injectable()
export class LoadingMethodService extends MescService {
    constructor(injector: Injector) { super(injector, "phf/LoadingMethod"); }
}

@Injectable()
export class OrientationService extends MescService {
    constructor(injector: Injector) { super(injector, "phf/Orientation"); }
}

@Injectable()
export class CommonHandlerService extends MescService {
    constructor(injector: Injector) { super(injector, "phf/CommonHandler/common"); }
}

@Injectable()
export class PlantService extends MescService {
    constructor(injector: Injector, private readonly cgpAlertDialog: CgpAlertDialogService) { super(injector, "phf/Plant"); }

    handleError = (errorResponse: any) => {
        let errorMessage = '';
        typeof errorResponse.error === "string" ? errorMessage = errorResponse.error : errorMessage = errorResponse.statusText;

        this.cgpAlertDialog.showAlertDialog({
            title: 'Plant Error: ',
            alert: 'danger',
            message: errorMessage,
            closeLabel: 'Close',
        })
    }
}

@Injectable()
export class ToolSetService extends MescService {
    constructor(injector: Injector) { super(injector, "PHF/ToolSet"); }
}

@Injectable()
export class PressService extends MescService {
    constructor(injector: Injector, private readonly cgpAlertDialog: CgpAlertDialogService) { super(injector, "phf/Press"); }

    handleError = (errorResponse: any) => {
        let errorMessage = '';
        typeof errorResponse.error === "string" ? errorMessage = errorResponse.error : errorMessage = errorResponse.statusText;

        this.cgpAlertDialog.showAlertDialog({
            title: 'Press Error: ',
            alert: 'danger',
            message: errorMessage,
            closeLabel: 'Close',
        })
    }
}

@Injectable()
export class ProgramService extends MescService {
    constructor(injector: Injector, private readonly cgpAlertDialog: CgpAlertDialogService) { 
        super(injector, "phf/Program"); 
        this.httpErrorHeader = "Program Error"
    }

}


